import { render, staticRenderFns } from "./nutritional-info.vue?vue&type=template&id=74cf4252&"
import script from "./nutritional-info.vue?vue&type=script&lang=js&"
export * from "./nutritional-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports